import { Input as NextInput } from "@heroui/react";
import { withFormComponent } from "./hoc";

export const Input = withFormComponent(NextInput);
